import { render, staticRenderFns } from "./InstallationInstructions.vue?vue&type=template&id=efa59e2a&"
import script from "./InstallationInstructions.vue?vue&type=script&lang=js&"
export * from "./InstallationInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports